export default __webpack_public_path__ + "static/media/stationerymockup.87907230.jpg";